import { render, staticRenderFns } from "./CallFlowDeleteModal.vue?vue&type=template&id=0fd24c5e"
import script from "./CallFlowDeleteModal.vue?vue&type=script&lang=js"
export * from "./CallFlowDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports